import * as Immutable from 'immutable';
import {
  GET_ADMINDATAISSUEMAINTENANCEMODE_REQUESTED,
  GET_ADMINDATAISSUEMAINTENANCEMODE_COMPLETED,
  GET_ADMINDATAISSUEMAINTENANCEMODE_FAILED,
  SET_ADMINDATAISSUEMAINTENANCEMODE_REQUESTED,
  SET_ADMINDATAISSUEMAINTENANCEMODE_COMPLETED,
  SET_ADMINDATAISSUEMAINTENANCEMODE_FAILED,
  GET_ADMINDATAISSUEMAINTENANCEMODEACCOUNTS_REQUESTED,
  GET_ADMINDATAISSUEMAINTENANCEMODEACCOUNTS_COMPLETED,
  GET_ADMINDATAISSUEMAINTENANCEMODEACCOUNTS_FAILED,
} from '../../actions/admindataissuemaintenancemode/types';

const schema = {
  // status: 'INIT', // INIT/OK/ERROR
  error: null,
  data: null,
  accounts: null,
  gettingdata: false,
  settingdata: false,
  gotdata: false,
  setdata: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMINDATAISSUEMAINTENANCEMODEACCOUNTS_REQUESTED:
      return state
        .set('error', null)
        .set('accounts', null)
        .set('gettingdata', true);

    case GET_ADMINDATAISSUEMAINTENANCEMODEACCOUNTS_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('accounts', action.payload);

    case GET_ADMINDATAISSUEMAINTENANCEMODEACCOUNTS_FAILED:
      return state.set('error', action.payload);
    case GET_ADMINDATAISSUEMAINTENANCEMODE_REQUESTED:
      return state
        .set('error', null)
        .set('data', null)
        .set('gettingdata', true);

    case GET_ADMINDATAISSUEMAINTENANCEMODE_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('data', action.payload);

    case GET_ADMINDATAISSUEMAINTENANCEMODE_FAILED:
      return state.set('error', action.payload);

    case SET_ADMINDATAISSUEMAINTENANCEMODE_REQUESTED:
      return state
        .set('error', null)
        .set('data', null)
        .set('settingdata', true);

    case SET_ADMINDATAISSUEMAINTENANCEMODE_COMPLETED:
      return state
        .set('error', null)
        .set('settingdata', false)
        .set('setdata', true)
        .set('data', action.payload);

    case SET_ADMINDATAISSUEMAINTENANCEMODE_FAILED:
      return state.set('error', action.payload);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
